/**
 * Стан картки в адресі (аудит якості № 2, 3): вкладка центру `?tab=` і пошук «Усіх полів» `?q=`.
 * Розбір — у `validateSearch` маршруту `/r/…` (app/routes/record.ts, перший екран) і в самій
 * картці; модуль без залежностей, щоб не тягнути код картки в основний чанк.
 */

/** Межа довжини параметра картки в адресі, символів. */
export const CARD_PARAM_MAX = 200;

/**
 * Вкладка з адреси: лише схожа на id вкладки (`fields`, `history`, `rel:<зв'язок>`, `slot:<id>`).
 * «Стрічка» зазвичай без параметра (`feed` — лише поруч із панеллю `?open=`, яка інакше відкриває
 * свою вкладку). Чи є така вкладка в картці, вирішує картка: немає — «Стрічка».
 */
export function tabParamOf(value: unknown): string | undefined {
  return typeof value === 'string' && /^[a-z][\w.:@-]{0,199}$/i.test(value) ? value : undefined;
}

/** Пошук «Усіх полів» з адреси; немає — порожній рядок. */
export function queryParamOf(value: unknown): string {
  return typeof value === 'string' ? value.slice(0, CARD_PARAM_MAX) : '';
}
